import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { getCobranzaEmailStatusPresentation } from "./cobranzaGestionUtils";

export default function CobranzaEmailStatusBadge({ entry, className = "" }) {
  const { t } = useTranslation("cobranza");
  const status = String(entry?.emailStatus || "").trim().toLowerCase();
  const presentation = getCobranzaEmailStatusPresentation(status, t);
  const statusAt = entry?.emailStatusAt;
  const title =
    statusAt && moment(statusAt).isValid()
      ? `${presentation.label} · ${moment(statusAt).format("DD/MM/YYYY HH:mm")}`
      : presentation.label;

  return (
    <span
      className={`cf-gestion-email-status ${presentation.className} ${className}`.trim()}
      title={title}
    >
      {presentation.label}
    </span>
  );
}
